export const allergenic: string = 'All products are made in a kitchen that handles NUTS, DAIRY, EGGS, GLUTEN, SOYA, PEANUTS and other ALLERGENIC ingredients'
